import { render, staticRenderFns } from "./PersonalLinkList.vue?vue&type=template&id=23db0413&scoped=true"
import script from "./PersonalLinkList.vue?vue&type=script&lang=js"
export * from "./PersonalLinkList.vue?vue&type=script&lang=js"
import style0 from "./PersonalLinkList.vue?vue&type=style&index=0&id=23db0413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db0413",
  null
  
)

export default component.exports